import React from 'react';
import { useParams } from 'react-router';

import { ProcessDetailsMultiOffers } from '@/views/processesDetails/components/multiOffers/ProcessDetailsMultiOffers.comp.tsx';

export const ProcessDetailsMultiOffersTab: React.FC = () => {
  const { processId } = useParams();

  if (!processId) {
    return null;
  }

  return <ProcessDetailsMultiOffers processId={processId} />;
};
